import styled from 'styled-components'
import { Trigger } from '@radix-ui/react-dropdown-menu'

export const DropdownTrigger = styled(Trigger)`
  svg {
    color: ${({ theme }) => theme.colors.white0};
  }
`


